export default () => ({
    init() {
        const hash = window.location.hash.replace(/^#/, '');
        if (!hash) {
            return;
        }
        const target = document.getElementById(hash);
        if (!target) {
            return;
        }
        setTimeout( () => {
            const rect = target.getBoundingClientRect();
            // scroll only if default browser scrolling misplaced the target
            if (rect.top <= 100) {
                console.log('scroll to', rect.top + window.scrollY - 105);
                window.scroll({
                    top: rect.top + window.scrollY - 105
                })
            }
        }, 1);

    }
});
